module.exports = __webpack_public_path__ + "static/media/emancipation.ecc324e8.png";